/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { RecommendService } from '../service/RecommendService';
import { RecommendCriteriaJson } from '../json/JsonAll';
import { RecommendJson } from '../json/JsonAll';
import { RecommendListJson } from '../json/JsonAll';
import { SelectItemJson } from '../json/JsonAll';
import { PackJson } from '../json/JsonAll';
import { RecommendUpdateListHistoryJson } from '../json/JsonAll';
import { PackVideoCriteriaJson } from '../json/JsonAll';
import { DeleteJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * おすすめ画面について出力処理およびイベント処理を行う。
 */
export class RecommendController extends PjBaseController {

    // おすすめ登録名
    public title: string;

    // 開始日
    public startDate: string;

    // 終了日
    public endDate: string;

    // グリッド情報
    public gridOptions: any;

    // 前回検索情報
    public criteria: RecommendCriteriaJson;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected recommendService: RecommendService,
            protected $location: ng.ILocationService,
            protected $http: ng.IHttpService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form21.title');
        this.gridOptions = {
            columnDefs: [
                {
                    field: 'title',
                    displayName: 'item.0008',
                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'videoCount',
                    displayName: 'item.0108',
                    width: '13%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'groupCount',
                    displayName: 'item.0107',
                    width: '17%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'startDate',
                    displayName: 'item.0011',
                    width: '11%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'endDate',
                    displayName: 'item.0047',
                    width: '11%',
                    headerCellFilter: 'translate'
                }
            ],
            enableRowSelection: true,
            enableSelectAll: true,
            enableColumnMenus: false,
            enableHorizontalScrollbar: 0,
            enableColumnResizing: true,
            paginationPageSizes: [10, 25, 100],
            paginationPageSize: 10,
            onRegisterApi: (gridApi: any) : void => {
                this.$scope.gridApi = gridApi;
            },
        };
        this.draw();
        this.$scope.show = (id: string) => {
            return this.show_dialog(id);
        };

        //  sharedService
        let auth: any;

        auth = sharedService.get('auth');
        //  権限が無いユーザはTOPへ戻す
        if (auth.role !== 2) {
            this.$location.url('/top');
        }
        //  項目の表示制御(トーマツ)
        $scope.tohmatsu = this.isTohmatsu();
        //  読み取り専用か判定
        $scope.readUser = this.isReadonly();
    }

    /**
     * ダイアログ表示
     */
    public show_dialog(id: string = null): void {
        let test: any = this.$uibModal.open({
            templateUrl: 'template/recommend/edit.html',
            controller: 'recommendEditController',
            controllerAs: 'recommendEdit',
            resolve: {
                id: function (): string {
                    return id;
                }
            },
        }).result.then((result: string) => {
            if (result) {
                this.clearAlert();
                if (result === 'delete') {
                    this.setAlert('message.0027');
                }
                this.reflesh_list(result);
            }
        });
    }

    public reflesh_list(result: string): void {
        this.recommendService.list(this.criteria).then((data: any) => {
            this.$scope.gridApi.selection.clearSelectedRows();
            this.gridOptions.data.splice(0, this.gridOptions.data.length);
            Array.prototype.push.apply(this.gridOptions.data, data.data.recommends);
            if (result !== 'delete') {
                this.clearAlert();
                if (data.status === 204) {
                    this.setAlert('message.0004');
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 検索処理
     */
    public search(): void {
        let criteria: any = {
            title: this.title,
            startDate: this.startDate,
            endDate: this.endDate
        };
        this.criteria = criteria;
        this.reflesh_list('search');
    }

    public delete(): void {
        let rows: RecommendJson[] = this.$scope.gridApi.selection.getSelectedRows();
        if (rows.length === 0) {
            alert(this.$translate.instant('MC0000001'));
            return;
        }
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        this.recommendService.delete(rows.map((x: RecommendJson) => {return x.id; })).then((data: DeleteJson) => {
            this.clearAlert();
            this.setAlert('message.0027');
            this.reflesh_list('delete');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}

export class RecommendEditController extends PjBaseController {

    // モーダル画面タイトル
    public modalTitle: string;

    // 更新ボタン見出し
    public submitCaption: string;

    // 画面情報
    public record: RecommendJson;

    // グリッド情報
    public gridOptions: any;

    // グループボックス数管理配列
    public groupSelectedItem: any = [];

    // グループボックス数管理配列
    public groupSelectedItemSub: any = [];

　　// 選択肢
    public selected: any = [];

　　// 登録対象
    public targets: any = [];

　　// 表示規則
    public sortableOptions: any;

    // パック情報
    public packInfo: PackJson;

    // 動画タイトル
    public videoTitle: string;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected recommendService: RecommendService,
            protected $location: ng.ILocationService,
            protected $scope: any,
            protected uiSortableMultiSelectionMethods: any,
            protected id: number = null) {
        super($stateParams, $translate, $location, pjInjectProxy);
        if (id) {
            this.modalTitle = 'form23.title';
            this.submitCaption = 'RC0000004';
            this.gridOptions = {
                columnDefs: [
                    {
                        field: 'userName',
                        displayName: 'item.0092',
                        width: '28%',
                        headerCellFilter: 'translate'
                    },
                    {
                        field: 'title',
                        displayName: 'item.0065',
                        headerCellFilter: 'translate'
                    },
                    {
                        field: 'groupName',
                        displayName: 'item.0035',
                        headerCellFilter: 'translate'
                    },
                    {
                        field: 'viewingDate',
                        displayName: 'item.0044',
                        width: '18%',
                        headerCellFilter: 'translate',
                        enableFiltering: false
                    }
                ],
                enableFiltering: true,
                enableColumnMenus: false,
                enableHorizontalScrollbar: 0,
                enableColumnResizing: true,
                paginationPageSizes: [10, 25, 100],
                paginationPageSize: 10,
                onRegisterApi: (gridApi: any) : void => {
                    this.$scope.gridApi = gridApi;
                },
            };
            this.draw();

            this.recommendService.getRecord(id).then((data: any) => {
                this.record = data.data.recommend;
                //  グループリスト取得
                this.recommendService.getGroupList().then((editMainData: any) => {
                    $scope.groupList = editMainData.data.groups;
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });

                //  this.record.groupIdの要素数を区切り配列化
                let groupStr: string = this.record.groupId;
                let groupAry: string[] = groupStr.split(',');
                //  先頭のgroupIdのみgroupSelectedItemに設定
                this.groupSelectedItem = groupAry[0];

                //  先頭以外の登録済みグループリストを設定
                for (let i: number = 1; i < groupAry.length; i++) {
                    this.groupSelectedItemSub.push(groupAry[i]);
                }

                //  パックリスト取得
                this.recommendService.getPackList().then((editMainData: any) => {
                    $scope.packList = editMainData.data.packs;
                }).catch((errorData: any) => {
                    this.catch(errorData);
                });

                //  this.record.videoIdから、登録済み動画をthis.targetsに描画する
                //  this.record.groupIdの要素数を区切り、数をカウント
                let videoStr: string = this.record.videoId;
                let videoIdAry: string[];
                if (videoStr == "null") {
                    videoIdAry = [];
                } else {
                    videoIdAry = videoStr.split(',');
                }

                //  videotitleを格納
                let videoTitleAry: string[] = this.record.videoTitle;

                //  配列結合
                let inList: any = [];
                for (let j: number = 0; j < videoIdAry.length; j++) {
                    inList.push({'id': videoIdAry[j], 'title': videoTitleAry[j]});
                }
                //  選択済みリストを表示
                this.selected = [];
                this.targets = inList;
                this.record.startDate = new Date(this.record.startDate);
                this.record.endDate = new Date(this.record.endDate);
                //  視聴履歴の表示制御
                $scope.log = true;
                this.getUserHistory(id);
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            this.record = {};
            this.modalTitle = 'form22.title';
            this.submitCaption = 'RC0000002';
            //  グループリスト取得
            this.recommendService.getGroupList().then((newMainData: any) => {
                this.groupSelectedItem = null;
                $scope.groupList = newMainData.data.groups;
            }).catch((errorData: any) => {
                this.catch(errorData);
            });

            //  パックリスト取得
            this.recommendService.getPackList().then((editMainData: any) => {
                $scope.packList = editMainData.data.packs;
            }).catch((errorData: any) => {
                this.catch(errorData);
            });

            this.selected = [];
            this.targets = [];

            //  視聴履歴の表示制御
            $scope.log = false;
        }

        this.sortableOptions = uiSortableMultiSelectionMethods.extendOptions({
            'axis '  : 'y',
            'cursorAt': { top: 25 },
            'start'  : function(event: any, ui: any): any {
            },
            'stop'   : function(event: any, ui: any): any {
            },
            'connectWith': '.apps-container',
            'placeholder': 'app',
            'update': (event: any, ui: any): void => {
                if (ui.item.sortable.received) {
                    return;
                }
                if (ui.item.sortable.sourceModel === this.selected &&
                      ui.item.sortable.droptargetModel === this.targets) {
                    for (let i: number = 0; i < ui.item.sortableMultiSelect.selectedModels.length; i++) {
                        if (this.targets.filter((x: any): boolean => {return x.id === ui.item.sortableMultiSelect.selectedModels[i].id; }).length) {
                            ui.item.sortable.cancel();
                            window.alert(this.$translate.instant('message.0050'));
                            break;
                        }
/*
                    //  ドラッグ中の動画群と選択された動画を合わせた中で、動画idが重複するかをチェック
                    let allVideo: any[] = [];
                    //  ドラッグ中の動画id
                    allVideo = ui.item.sortableMultiSelect.selectedModels.map((x: any) => {return x.id; });
                    //  選択された動画id
                    allVideo = allVideo.concat(this.targets.map((x: any) => {return x.id; }));
                    //  重複を取り除いた動画id
                    let inVideo: any[] = [];
                    inVideo = allVideo.filter(function (x: any, i: any, self: any): any {
                        return self.indexOf(x) === i && x !== '';
                    });
                    if (allVideo.length !== inVideo.length) {
                        ui.item.sortable.cancel();
                        window.alert(this.$translate.instant('message.0050'));
                    }
*/
                    }
                }
            }
        });
    }

    public searchVideo(): any {
        this.selected = [];
        let criteria: any = {
            title: this.videoTitle,
            packId: this.$scope.packSelectedItem || null
        };
        this.recommendService.getVideoList(criteria).then((data: any) => {
            this.clearAlert();
            if (data.status === 204) {
                this.setAlert('message.0004');
            } else {
                let dataLength: any = data.data.recommends.length;
                this.selected = data.data.recommends.splice(0, 100);
                if (dataLength > 100) {
                    this.setAlert('message.0048');
                }
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public getUserHistory(id: number): any {
        this.recommendService.getUserHistory(id).then((data: any) => {
            if (this.gridOptions.data === undefined || this.gridOptions.data === null) {
                this.gridOptions.data = data.data.recommends;
            } else {
                this.gridOptions.data.splice(0, this.gridOptions.data.length);
                Array.prototype.push.apply(this.gridOptions.data, data.data.recommends);
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public delete(): void {
        if (!window.confirm(this.$translate.instant('CC0000001'))) {
            return;
        }
        this.recommendService.delete([this.id]).then((data: DeleteJson) => {
            this.$uibModalInstance.close('delete');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    public update(): void {
        //  登録対象の動画重複チェック
        let targetId: any = [];
        let targetLen: number = this.targets.length || 0;

        for (let i: number = 0; i < targetLen; i++) {
            targetId.push(this.targets[i].id);
        }

        let c: any[] = targetId.filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) !== self.lastIndexOf(x);
        });

        if (c.length !== 0) {
            console.log('NG');
        //    window.alert(this.$translate.instant('message.0050'));
            return;
        }
        // グループID重複チェック
        let dammyGrp: any[];
        dammyGrp = this.groupSelectedItem.split(',');
        dammyGrp = dammyGrp.concat(this.groupSelectedItemSub);
        dammyGrp = dammyGrp.filter(function (x: any, i: any, self: any): any {
            return x !== '';
        });
        // 選択されたグループIDの総数
        let allGrpIdCnt: number = dammyGrp.length;
        let dammyGrp2: any[] = dammyGrp.filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) === i && x !== '';
        });
        // 重複を除外したグループIDの数
        let selGrpIdCnt: number = dammyGrp2.length;
        if (allGrpIdCnt !== selGrpIdCnt) {
            this.clearAlert();
            this.setAlert('message.0059');
            return;
        }

        this.record.videoId = this.targets.map((x: any) => {return x.id; }).filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) === i && x !== '';
        }).join(',');

        this.record.groupId = dammyGrp.filter(function (x: any, i: any, self: any): any {
            return self.indexOf(x) === i && x !== '';
        }).join(',');

        if (this.id === null) {
            this.recommendService.create(this.record).then((data: RecommendJson) => {
                this.$uibModalInstance.close('create');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        } else {
            this.recommendService.update(this.record).then((data: RecommendJson) => {
                this.$uibModalInstance.close('update');
            }).catch((errorData: any) => {
                this.catch(errorData);
            });
        }
    }

    // 追加削除button
    public add(): any {
        this.groupSelectedItemSub.push('');
    }

    public del(indexNum: number): any {
        this.groupSelectedItemSub.splice(indexNum, 1);
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/RecommendController.ts
 **/